interface IcoDangerProps {
    className?: string;
}

function IcoDanger({ className }: IcoDangerProps = {}) {
    return (
    <svg className={className} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_948_467)">
            <path d="M7 0C3.13429 0 0 3.13429 0 7C0 10.8657 3.13429 14 7 14C10.8657 14 14 10.8657 14 7C14 3.13429 10.8663 0 7 0ZM6.99731 11.2888C6.55317 11.2888 6.19312 10.9288 6.19312 10.4846C6.19312 10.0405 6.55317 9.68045 6.99731 9.68045C7.44144 9.68045 7.80149 10.0405 7.80149 10.4846C7.80149 10.9288 7.44144 11.2888 6.99731 11.2888ZM7.80149 7.94271C7.80149 8.38685 7.44144 8.7469 6.99731 8.7469C6.55317 8.7469 6.19312 8.38685 6.19312 7.94271V3.5574C6.19312 3.11327 6.55317 2.75321 6.99731 2.75321C7.44144 2.75321 7.80149 3.11327 7.80149 3.5574V7.94271Z" fill="currentColor"/>
        </g>
        <defs>
            <clipPath id="clip0_948_467">
                <rect width="14" height="14" fill="white"/>
            </clipPath>
        </defs>
    </svg>

    );
}

export default IcoDanger;

